<template lang="pug">
.custom-title-wrap(:class="className")
  .custom-title.primary--text.font-weight-bold
    slot
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
    },
  },
  computed: {
    className() {
      return `custom-title-align-${this.align}`;
    },
  },
};
</script>

<style>
.custom-title-wrap {
  display: flex;
}
.custom-title {
  position: relative;
  font-size: 28px;
  line-height: 33.6px;
  padding-top: 18px;
  max-width: max-content;
}
.custom-title::before {
  content: "";
  width: 105px;
  height: 4px;
  background-color: var(--v-secondary-base);
  position: absolute;
  top: 0;
}
.custom-title-align-center {
  justify-content: center;
}
.custom-title-align-center .custom-title::before {
  left: calc(50% - (105px / 2));
}
</style>